<template>
	<div v-show="show_view" class="person shadow-sm border-radius-1" :class="css_selector">
		<div class="header">
			<h3>{{team_member.name.first}} {{team_member.name.initials}} {{team_member.name.last}}</h3>
			<div>{{team_member.qualifications}}</div>
			<div>{{team_member.position}}</div>
		</div>
		<div v-html="team_member.about" class="body" />
	</div>
</template>

<script>
export default {
	name: 'team-member',
	props: {
		team_member : {
			type: Object,
			required: true
		},
		index : {
			type: Number,
			required: true
		}
	},
	components: {
	},
	data() {
		return {
			show_view: false,
			css_selector: 'person' + this.index 
		};
	},
	mounted() {
		setTimeout(() => {
			setTimeout(() => {
				this.show_view = true;
			}, this.index * 100);
		}, 250);
	},
};
</script>

<style lang="scss" scoped>
	@import '../assets/style/main.scss';
	.person {
		margin-top: 1em;
		margin-bottom: 4em;
		animation: flip-in-up 500ms ease-in-out both;
		background-color: $white;
		border: none;
		* {
			letter-spacing: 0.1px;
		}
		>div {
			padding: 0.5em 1em;
		}
		>.header {
			background-color: $gray-light;
			color: $white;
			padding: 1em;
			>h3 {
				margin: 0px;
			}
		}
		>.body {
			background-color: $white;
			color: $gray;
		}
	}
</style>